import hopTimusAvatar from '@/hoc/HopTimusButton/hoptimus-avatar.png'
import { AvatarFrame, AvatarImage, AvatarWrapper, OnlineDot } from './styled-components'

const HopTimusAvatar = () => (
  <AvatarWrapper>
    <AvatarFrame>
      <AvatarImage src={hopTimusAvatar} alt='' />
    </AvatarFrame>
    <OnlineDot aria-hidden='true' />
  </AvatarWrapper>
)

export default HopTimusAvatar
